import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import {
  Button,
  ButtonsWrapper,
  EmptyContainer,
  EMPTY_ILLUSTRATIONS,
} from '@thinknet-gmbh/platform-common-ui';

import { ROUTES } from 'src/components/app/app-routes.constants';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  return (
    <EmptyContainer
      illustration={EMPTY_ILLUSTRATIONS.error}
      emptyTitle={t('notFoundPage.title')}
      contentText={t('notFoundPage.subTitle')}
    >
      <ButtonsWrapper marginTop={16}>
        <Button type="primary" onClick={() => navigate(ROUTES.dashboard)}>
          {t('notFoundPage.button')}
        </Button>
      </ButtonsWrapper>
    </EmptyContainer>
  );
};
export default NotFound;
